// Convert Web Components to React Components
import ReactLauncher from './ReactLauncher';
import * as serviceWorker from './serviceWorker';

// Components
import App from './App';
import Hello from './components/Hello';
import Simulator from './components/Simulator';
// import PCOEvents from './components/PCOEvents/PCOEvents';
import TCCGroups from './components/Groups/TCCGroups';
import TCCGroupsForm from './components/Groups/TCCGroupsForm';
import TCCPrayerRequests from './components/PrayerRequests/TCCPrayerRequests';
import TCCAnnouncements from './components/Announcements/TCCAnnouncements';
import CCBEvents from './components/CCBEvents/CCBEvents';
import TCCRSSReader from './components/RSSReader/TCCRSSReader';
import { TCCPodcasting } from './components/Podcasting/TCCPodcasting'
import { TCCCalendar } from './components/Events/TCCCalendar'
import { PushPayGroups } from './components/PushPay/PushPayGroups';
import { PCOGroups } from './components/PCO/PCOGroups';

// Make Components Accessible
ReactLauncher([
    { tagName: 'App', component: App },
    { tagName: 'Hello', component: Hello },
    { tagName: 'Simulator', component: Simulator },
    // {tagName: 'PCOEvents', component: PCOEvents},
    { tagName: 'TCCGroups', component: TCCGroups },
    { tagName: 'TCCGroupsForm', component: TCCGroupsForm },
    { tagName: 'TCCPrayerRequests', component: TCCPrayerRequests },
    { tagName: 'TCCAnnouncements', component: TCCAnnouncements },
    { tagName: 'CCBEvents', component: CCBEvents },
    { tagName: 'TCCRSSReader', component: TCCRSSReader },
    { tagName: 'TCCPodcasting', component: TCCPodcasting },
    { tagName: 'TCCCalendar', component: TCCCalendar },
    { tagName: 'PushPayGroups', component: PushPayGroups },
    { tagName: 'PCOGroups', component: PCOGroups }
]);

// Service Worker
serviceWorker.unregister();
